import ParkingLots from './parking-lots';
import ParkingEvents from './parking-events';
import Folders from './folders';

const ParkingLotsApi = new ParkingLots();
const ParkingEventsApi = new ParkingEvents();
const FoldersApi = new Folders();

/* eslint-disable */
export {
  ParkingLotsApi,
  ParkingEventsApi,
  FoldersApi
};
